/**
 * Currency formatting utilities.
 */

import { positionCurrencySymbolAroundText } from './currency-symbol-placement.js';

export {
    addSpaceAfterCurrencySymbol,
    formatCurrencyAmount,
    formatCurrencySample,
    getCurrencyFormattingContext,
    getCurrencySymbolPositionFromSample,
    resetCurrencyFormattingContext,
    setCurrencyFormattingContext,
} from './currency-intl.js';

export {
    appendCurrencySymbolByLocale,
    positionCurrencySymbolAroundText,
} from './currency-symbol-placement.js';

/**
 * Position a currency symbol around a text value, following locale conventions.
 *
 * @param {string} text
 * @param {string} [currencySymbol='']
 * @param {string} [currencyName]
 * @param {string} [locale]
 * @returns {string|undefined}
 */
export const getStringAsCurrency = (text, currencySymbol = '', currencyName, locale) => {
    return positionCurrencySymbolAroundText(text, currencySymbol, currencyName || 'EUR', locale);
};
